import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { computeDlHashIdForCgdo } from 'app/shared/utils/dlHashId';
import { selectAgentOrgID } from 'app/modules/session/selectors';
import { selectHashedIdRoutesEnabled } from 'app/shared/featureFlags/selectors';

export const useEntityHashedId = (
  externalId: string,
): { hashedId: string; useHashed: boolean } => {
  const orgId = useSelector(selectAgentOrgID);
  const hashedIdRoutesEnabled = useSelector(selectHashedIdRoutesEnabled);
  const hashedId = useMemo(
    () =>
      hashedIdRoutesEnabled && externalId
        ? computeDlHashIdForCgdo(orgId, externalId)
        : '',
    [hashedIdRoutesEnabled, externalId, orgId],
  );
  return { hashedId, useHashed: Boolean(hashedId) };
};
